import React from 'react';
import './styles/separator.scss';

export default function Separator() {
  return <div className="buttonmenu-sep" />;
}
